import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "../../../../boot";

// Get products
export const getWalkthroughList = createAsyncThunk("/get-walkthroughList", async (data, { rejectWithValue }) => {
  const token = localStorage.getItem("authToken");

  try {
    const response = await axios.post(`${baseUrl}crm/api/v1/get-walkthroughs?size=${data.size}`, data, {
      headers: {
        "auth-token": token,
        "Content-Type": "application/json",
      },
    });
    console.log("brand  re response", response);
    return response; // ✅ Return only the data
  } catch (error) {
    console.error("Error fetching products r:", error);

    // ✅ Handle errors properly
    return rejectWithValue(error.response?.data?.message || "Failed to fetch products");
  }
});
